<h1 mat-dialog-title>{{ 'Logs' | translate }}</h1>

@if (job?.logs_excerpt) {
  <div class="logs">
    <pre><code>{{ job.logs_excerpt }}</code></pre>
    <ix-copy-button [text]="job.logs_excerpt"></ix-copy-button>
  </div>
}

<div mat-dialog-actions>
  <button
    mat-button
    matDialogClose
    ixTest="close"
  >
    {{ 'Close' | translate }}
  </button>
  <button
    mat-button
    color="primary"
    ixTest="download-logs"
    (click)="downloadLogs()"
  >
    {{ 'Download Logs' | translate }}
  </button>
</div>
